/*
 *  Copyright (C) GridGain Systems. All Rights Reserved.
 *  _________        _____ __________________        _____
 *  __  ____/___________(_)______  /__  ____/______ ____(_)_______
 *  _  / __  __  ___/__  / _  __  / _  / __  _  __ `/__  / __  __ \
 *  / /_/ /  _  /    _  /  / /_/ /  / /_/ /  / /_/ / _  /  _  / / /
 *  \____/   /_/     /_/   \_,__/   \____/   \__,_/  /_/   /_/ /_/
 */

import { humanCompare } from '@common/utils/human-compare';
import { Cluster3xDistributionZone, Cluster3xZoneName } from '@shared/types/distribution-zone';

export const sortZonesByName = (tables: Cluster3xDistributionZone[]) =>
  [...tables].sort((a, b) => humanCompare(a.zoneName, b.zoneName));

export const findZoneByName = (zones: Cluster3xDistributionZone[], zoneName: Cluster3xZoneName) =>
  zones.find((it) => it.zoneName.toLowerCase() === zoneName.toLowerCase());
